/**
 * These schemata are used when a user or machine is added to an Org.
 */
import { object, string, type InferType } from "yup"
import { UserOrgsRolesSchema } from "./UserOrgs"

/**
 * This schema is transfered from the FE to the BE.
 */
export const AddToOrgschema = object({
  // ext_sn -- not part of the schema, because ext_sn is sent as path parameter
  orgId: string().required(),
  orgRole: UserOrgsRolesSchema.optional(), // optional, because users have it, machines don't
})

export type AddToOrgDto = InferType<typeof AddToOrgschema>
